<template>
  <div class="driver-profile">
    <!-- 顶部导航 -->
    <header class="header">
      <button class="btn-icon" @click="$router.push('/delivery/grab-hall')">←</button>
      <div class="header-center">{{ $t('driverProfile.title') }}</div>
      <div style="width: 24px;"></div>
    </header>

    <!-- 用户信息卡片 -->
    <div class="profile-header">
      <div class="user-avatar">🚴</div>
      <div class="user-info">
        <div class="user-name">{{ userInfo.name || $t('driverProfile.driver') }}</div>
        <div class="user-phone">{{ $t('driverProfile.phone') }}: {{ userInfo.phone || $t('driverProfile.notSet') }}</div>
        <div class="user-status">
          <span :class="['status-badge', userInfo.isOnline ? 'online' : 'offline']">
            {{ userInfo.isOnline ? $t('driverProfile.online') : $t('driverProfile.offline') }}
          </span>
        </div>
      </div>
    </div>

    <!-- 统计数据 -->
    <div class="stats-section">
      <div class="stat-item">
        <div class="stat-value">{{ stats.todayTasks }}</div>
        <div class="stat-label">{{ $t('driverProfile.todayTasks') }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.completedTasks }}</div>
        <div class="stat-label">{{ $t('driverProfile.completed') }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.totalEarnings }}</div>
        <div class="stat-label">{{ $t('Delivery.Profile.line36_text') }}</div>
      </div>
    </div>

    <!-- 功能菜单 -->
    <div class="menu-section">
      <div class="menu-group">
        <div class="menu-item" @click="$router.push('/delivery/grab-hall')">
          <span class="menu-icon">📦</span>
          <span class="menu-label">{{ $t('driverProfile.deliveryTasks') }}</span>
          <span class="menu-arrow">›</span>
        </div>
        <div class="menu-item" @click="$router.push('/delivery/grab-hall')">
          <span class="menu-icon">🏃</span>
          <span class="menu-label">{{ $t('driverProfile.grabHall') }}</span>
          <span class="menu-arrow">›</span>
        </div>
        <div class="menu-item" @click="$router.push('/delivery/orders')">
          <span class="menu-icon">📋</span>
          <span class="menu-label">{{ $t('driverProfile.orderRecords') }}</span>
          <span class="menu-arrow">›</span>
        </div>
      </div>

      <div class="menu-group">
        <div class="menu-item" @click="showChangePassword = true">
          <span class="menu-icon">🔐</span>
          <span class="menu-label">{{ $t('driverProfile.changePassword') }}</span>
          <span class="menu-arrow">›</span>
        </div>
      </div>
    </div>

    <!-- 退出登录 -->
    <div class="logout-section">
      <button class="btn-logout" @click="handleLogout()">{{ $t('driverProfile.logout') }}</button>
    </div>

    <!-- 删除账号 -->
    <div class="delete-account-section">
      <button class="btn-delete-account" @click="showDeleteAccount = true">{{ $t('common.deleteAccount') }}</button>
    </div>

    <!-- 修改密码弹窗 -->
    <ChangePasswordModal :visible.sync="showChangePassword" />

    <!-- 删除账号弹窗 -->
    <div class="delete-account-modal" v-if="showDeleteAccount">
      <div class="modal-overlay" @click="showDeleteAccount = false">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h3>{{ $t('Delivery.Profile.line87_text') }}</h3>
            <button class="close-btn" @click="showDeleteAccount = false">×</button>
          </div>
          <div class="modal-body">
            <p class="warning-text">{{ $t('Delivery.Profile.line91_text') }}</p>
            <ul class="warning-list">
              <li>{{ $t('Delivery.Profile.line93_text') }}</li>
              <li>{{ $t('Delivery.Profile.line94_text') }}</li>
              <li>{{ $t('Delivery.Profile.line95_text') }}</li>
            </ul>
            <p class="warning-text danger">{{ $t('Delivery.Profile.line97_text') }}</p>
          </div>
          <div class="modal-footer">
            <button class="btn-cancel" @click="showDeleteAccount = false">{{ $t('common.cancel') }}</button>
            <button class="btn-confirm-danger" @click="confirmDeleteAccount">{{ $t('common.confirmDelete') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangePasswordModal from '@/components/ChangePasswordModal.vue';
import api from '@/services/api';

export default {
  name: 'DriverProfile',
  components: { ChangePasswordModal },
  data() {
    return {
      userInfo: {
        name: this.$t('driverProfile.driver'),
        phone: this.$t('driverProfile.notSet'),
        isOnline: false
      },
      stats: {
        todayTasks: 0,
        completedTasks: 0,
        totalEarnings: 0
      },
      showChangePassword: false,
      showDeleteAccount: false
    };
  },
  mounted() {
    this.loadUserInfo();
  },
  methods: {
    loadUserInfo() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      if (userInfo.username) {
        this.userInfo.name = userInfo.username;
      }
      if (userInfo.phone) {
        this.userInfo.phone = userInfo.phone;
      }
    },
    handleLogout() {
      if (confirm(this.$t('driverProfile.logoutConfirm'))) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_identity');
        localStorage.removeItem('userInfo');
        this.$router.replace('/login');
      }
    },
    async confirmDeleteAccount() {
      try {
        const res = await api.delete('/auth/account');
        if (res !== undefined && res !== null) {
          this.$toast?.success('账号已删除');
          this.showDeleteAccount = false;
          localStorage.clear();
          sessionStorage.clear();
          this.$router.replace('/login');
        } else {
          this.$toast?.error('删除失败');
        }
      } catch (error) {
        console.error('删除账号失败:', error);
        this.$toast?.error('删除失败：' + (error.response?.data?.message || error.message));
      }
    }
  }
};
</script>

<style scoped>
.driver-profile {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 20px;
}

/* ==================== 顶部导航 ==================== */
.header {
  background: white;
  border-bottom: 1px solid #eee;
  padding: calc(12px + env(safe-area-inset-top, 0px)) 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-center {
  flex: 1;
  text-align: center;
  font-weight: bold;
  color: #333;
  font-size: 16px;
}

.btn-icon {
  font-size: 20px;
  cursor: pointer;
  background: none;
  border: none;
  color: #333;
}

/* ==================== 用户信息卡片 ==================== */
.profile-header {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  padding: 24px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;
}

.user-avatar {
  font-size: 48px;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.2);
  border-radius: 50%;
}

.user-info {
  flex: 1;
}

.user-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 4px;
}

.user-phone {
  font-size: 12px;
  opacity: 0.9;
  margin-bottom: 4px;
}

.user-status {
  margin-top: 4px;
}

.status-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(255,255,255,0.3);
}

.status-badge.online {
  background: rgba(76, 175, 80, 0.8);
  color: white;
}

.status-badge.offline {
  background: rgba(158, 158, 158, 0.6);
  color: white;
}

/* ==================== 统计数据 ==================== */
.stats-section {
  background: white;
  margin: 12px;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-around;
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #4CAF50;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: #666;
}

/* ==================== 功能菜单 ==================== */
.menu-section {
  margin: 12px;
}

.menu-group {
  background: white;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  transition: background 0.2s;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:active {
  background: #f9f9f9;
}

.menu-icon {
  font-size: 20px;
  margin-right: 12px;
  width: 24px;
  text-align: center;
}

.menu-label {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.menu-arrow {
  font-size: 20px;
  color: #ccc;
}

/* ==================== 退出登录 ==================== */
.logout-section {
  padding: 24px 16px;
}

.btn-logout {
  width: 100%;
  padding: 14px;
  background: white;
  color: #f5576c;
  border: 1px solid #f5576c;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-logout:active {
  background: #f5576c;
  color: white;
}

/* ==================== 删除账号 ==================== */
.delete-account-section {
  padding: 12px 16px 24px;
}

.btn-delete-account {
  width: 100%;
  padding: 12px;
  background: none;
  color: #bbb;
  border: none;
  font-size: 13px;
  cursor: pointer;
}

.btn-delete-account:active {
  color: #999;
}
</style>